<template>
  <MainViewContainer>
    <div class="col-span-12">
      <h1>{{ $t('default.material_bank.title') }}</h1>
    </div>
    <div class="col-span-12 md:col-span-8 lg:col-span-6">
      <template v-if="ready">
        <p v-if="pages.length === 0">
          {{ $t('default.material_bank.empty') }}
        </p>
        <MaterialPageList v-else class="mt-4" :pages="pages" />
      </template>
    </div>
  </MainViewContainer>
</template>

<script>
import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import MainViewContainer from '@/components/MainViewContainer'
import MaterialPageList from '@/components/material-bank/MaterialPageList.vue'

export default {
  components: {
    MainViewContainer,
    MaterialPageList,
  },
  setup() {
    const store = useStore()
    const router = useRouter()
    const ready = ref(false)

    const pages = computed(() => store.state.materialBank.pages)

    onMounted(async () => {
      await store.dispatch('materialBank/fetchPages')
      const indexPage = store.getters['materialBank/indexPage']
      if (indexPage) {
        router.replace('/material/' + indexPage.path)
        return
      }
      ready.value = true
    })

    return {
      pages,
      ready,
    }
  },
}
</script>

<style scoped></style>
